<template>
	<div>
		<div class="top">
			<div class="info">
				<div class="left">
					<img src="../../assets/ld_img_avatar.png">
					{{profitInfo.name}}
				</div>
				<div class="right">
					<template v-if="profitInfo.orderStatus==-1">
						<img src="../../assets/i_icon_fxnote.png">待结算
					</template>
					<template v-if="profitInfo.orderStatus==0">
						<img src="../../assets/i_icon_fxnote.png">待结算
					</template>
					<template v-if="profitInfo.orderStatus==1">
						<img src="../../assets/i_icon_fxdjs.png">已结算
					</template>
					<template v-if="profitInfo.orderStatus==2">
						<img src="../../assets/i_icon_fxerror.png">已退款
					</template>
				</div>
			</div>
			<div class="top_main">
				<div class="state" v-if="profitType == 'lineProfit'">
					<template v-if="profitInfo.orderStatus==-1">
						<img src="../../assets/i_fxsy_dcx.png">
					</template>
					<template v-if="profitInfo.orderStatus==0">
						<img src="../../assets/i_fxsy_djs.png">
					</template>
					<template v-if="profitInfo.orderStatus==1">
						<img src="../../assets/i_fxsy_yjs.png">
					</template>
				</div>
				<h1>{{profitInfo.orderDataInfo.caption}}</h1>
				<div class="time">下单时间：{{profitInfo.orderDataInfo.orderTime}}</div>
				<div class="actime" v-if="profitType !== 'lineProfit'">
					<div class="od_left">
						<p>{{profitInfo.orderDataInfo.startDate}}</p>
						<p>{{profitInfo.orderDataInfo.startDateWeekText}}出发</p>
					</div>
					<div class="od_mid">
						<span>共{{profitInfo.orderDataInfo.totalDay}}天</span>
					</div>
					<div class="od_right">
						<p>{{profitInfo.orderDataInfo.endDate}}</p>
						<p>{{profitInfo.orderDataInfo.endDateWeekText}}返回</p>
					</div>
				</div>
			</div>
		</div>
		<div class="title"><img src="../../assets/i_icon_fxsyxqtitle.png">收益详情</div>
		<div class="content">
			<!-- 活动收益 -->
			<div class="activity_content" v-if="profitType !== 'lineProfit'">
				<div class="line line_top">
					<div>单件收益(元)</div>
					<p>订购量</p>
					<p>收益(元)</p>
				</div>
				<div class="line" v-for="(item, index) in profitInfo.service" :key="index">
					<p>{{item.profitPer}}</p>
					<p>{{item.nums}}</p>
					<p class="money">¥{{item.sumProfit}}</p>
				</div>
			</div>
			<!-- 路书收益 -->
			<template v-if="profitType == 'lineProfit'">
				<div class="line line_top">
					<div>项目</div>
					<div class="name">名称</div>
					<p>是否订购</p>
					<p>分销收益</p>
				</div>
				<div v-if="profitInfo.service.hotel.length">
					<template v-for="(item, hotelindex) in profitInfo.service.hotel">
						<div :class="['line',item.check=='4'?'brown':'']" :key="hotelindex">
							<b><span v-if="hotelindex==0">酒店</span></b>
							<div class="name">{{item.name}}</div>
							<p v-if="item.check==1">已订</p>
							<p v-if="item.check==4">已退款</p>
							<p class="money">¥{{item.profit}}</p>
						</div>
					</template>
					
				</div>
				<div v-if="profitInfo.service.scene.length">
					<template  v-for="(item, scenelindex) in profitInfo.service.scene">
						<div :class="['line',item.check=='4'?'brown':'']" :key="scenelindex">
								<b><span v-if="scenelindex==0">景区</span></b>
								<div class="name">{{item.name}}</div>
								<p v-if="item.check==1">已订</p>
								<p v-if="item.check==4">已退款</p>
								<p class="money">¥{{item.profit}}</p>
						</div>
					</template>
				</div>
				<template v-if="profitInfo.service.car.check!==0">
					<div class="line" :class="['line',profitInfo.service.car.check=='4'?'brown':'']">
						<b>租车</b>
						<div class="name">{{profitInfo.service.car.name}}</div>
						<p v-if="profitInfo.service.car.check==1">已订</p>
						<p v-if="profitInfo.service.car.check==4">已退款</p>
						<p class="money">¥{{profitInfo.service.car.profit}}</p>
					</div>
				</template>
				<template v-if="profitInfo.service.guide.check!==0">
					<div class="line" :class="['line',profitInfo.service.guide.check=='4'?'brown':'']">
						<b>领队</b>
						<div class="name">{{profitInfo.service.guide.name}}</div>
						<p v-if="profitInfo.service.guide.check==1">已订</p>
						<p v-if="profitInfo.service.guide.check==4">已退款</p>
						<p class="money">¥{{profitInfo.service.guide.profit}}</p>
					</div>
				</template>
				<template v-if="profitInfo.service.insurance.check!==0">
					<div class="line" :class="['line',profitInfo.service.insurance.check=='4'?'brown':'']">
						<b>保险</b>
						<div class="name">{{profitInfo.service.insurance.name}}</div>
						<p v-if="profitInfo.service.insurance.check==1">已订</p>
						<p v-if="profitInfo.service.insurance.check==4">已退款</p>
						<p class="money">¥{{profitInfo.service.insurance.profit}}</p>
					</div>
				</template>
				<div class="line_bottom">
					<p>合计</p>
					<b class="money">¥{{allProfit}}</b>
				</div>
			</template>
		</div>
		<div class="tips" v-if="profitType == 'lineProfit'">用户完成所有消费，次日12:00结算收益</div>
		<div class="tips" v-else>活动结束5个工作日内结算收益</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				itemId: '',
				profitType:'',
				profitInfo:{
					orderDataInfo:{},
					service:{
						hotel: [],
						scene: [],//是line里的check
						guide: {},
						car: {},
						insurance: {}
					}
				},
			};
		},
		computed: {
			allProfit() {
				var a = this.profitInfo.service.insurance.profit ? this.profitInfo.service.insurance.profit : 0;
				var b = this.profitInfo.service.guide.profit ? this.profitInfo.service.guide.profit : 0;
				var c = this.profitInfo.service.car.profit ? this.profitInfo.service.car.profit : 0;
				var d = 0;
				var e = 0;
				if (this.profitInfo.service.hotel) {
					this.profitInfo.service.hotel.map( item => {
						d += item.profit;
					});
				}
				if (this.profitInfo.service.scene) {
					this.profitInfo.service.scene.map( item => {
						e += item.profit;
					});
				}
				return (a + b + c + d + e).toFixed(2);
			},
			token() {
				return this.$store.getters.getToken
			},
			device() {
				return String(this.$store.state.device).toString().toLowerCase()
			},
		},
		mounted() {
			this.profitType = this.$route.query.profitType;
			this.itemId = this.$route.query.id;
			this.profitInfoData();
			// console.log(this.token)
			// console.log(this.device)
		},
		methods:{

			// 收益详情
			profitInfoData(){
				let that=this,url;
				if (this.profitType == 'lineProfit') {
					url = '/v2/api/w/distribution/line/profit_detail';
				} else {
					url = '/v2/api/w/distribution/activity/profit_detail';
				}
				this.$get(url,{
					id: that.itemId,
				}).then(function(res) {
					if(res.code==1000){
						console.log(res)
						that.profitInfo = res.data;
						that.profitInfo.service.hotel = res.data.service.hotel.filter(item => {
							return item.check !== 0;
						});
						that.profitInfo.service.scene = res.data.service.scene.filter(item => {
							return item.check !== 0;
						});
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
		},
	};
</script>

<style scoped>
	.actime {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
	}
	.od_left, .od_right {
		flex: 1;
		color: #848689;
		font-size: 16px;
		text-align: center;
	}
	.actime p{
		font-size: 13px;
	}
	.actime p:first-child{
		color: #232326;
		font-weight: 800;
		font-size: 16px;
		margin-bottom: 5px;
	}
	.od_mid {
		/* flex: 1; */
		width: 65px;
		font-size: 10px;
		color: #5F6B80;
		text-align: center;
		position: relative;
		margin: 0 20px;
		background: url(../../assets/i_line_stroke.png) no-repeat center;
		background-size: contain;
	}
	.od_mid span {
		background: #D6DFEE;
		border-radius: 1rem;
		padding: 0 7px;
	}
	.od_mid:before {
		content: ' ';
		display: block;
		position: absolute;
		top: 0rem;
		left: -15px;
		height: 15px;
		width: 15px;
		background: url(../../assets/i_icon_strokestart.png) no-repeat center;
		background-size: contain;
	}
	.od_mid:after {
		content: ' ';
		display: block;
		position: absolute;
		top: 0rem;
		right: -15px;
		height: 15px;
		width: 15px;
		background: url(../../assets/i_icon_strokeend.png) no-repeat center;
		background-size: contain;
	}
	.top{
		background: #606B80;
		border-radius: 15px;
		margin: 10px;
		overflow: hidden;
	}
	.info{
		display: flex;
		justify-content: space-between;
		font-size: 15px;
		color: #FFFFFF;
		margin: 15px;
	}
	.left,.right{
		display: flex;
		align-items: center;
	}
	.left img{
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 10px;
	}
	.right img{
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
	.top_main{
		background: #FFFFFF;
		border-radius: 8px;
		margin: 7.5px;
		padding: 12px;
	}
	.top_main h1{
		font-size: 15px;
		color: #39393F;
		line-height: 22.5px;
		margin-bottom: 10px;
	}
	.time{
		font-size: 13px;
		color: #979797;
	}
	.title{
		font-size: 16px;
		color: #39393F;
		margin: 15px;
		display: flex;
		align-items: center;
	}
	.title img{
		width: 20px;
		margin-right: 10px;
	}
	.content{
		font-size: 15px;
		margin: 15px 10px;
	}
	.line{
		color: #39393F;
		display: flex;
		padding: 10px;
		justify-content: space-between;
	}
	.line_top{
		color: #979797;
		background: #F2F3F4;
		border-radius: 8px;
		padding: 10px;
		margin-bottom: 10px;
	}
	.line_top p:last-child{
		text-align: right;
	}
	.line b{
		width: 30px;
	}
	.line p{
		width: 70px;
		text-align: center;
	}
	.line .name{
		width: auto;
		flex: 1;
		margin-left: 20px;
	}
	.line .money{
		text-align: right;
		font-weight: 600;
	}
	.activity_content .line .money{
		color: #606B80;
		text-align: center;
	}
	.line_bottom{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px;
	}
	.line_bottom p{
		font-size: 15px;
		color: #39393F;
	}
	.line_bottom .money{
		font-size: 25px;
		color: #606B80;
	}
	.tips{
		font-size: 13px;
		color: #979797;
		line-height: 21px;
		margin: 15px;
	}
	.state img{
		width: 100%;
	}
	.brown{
		color: #979797;
	}
</style>
